module.exports = __webpack_public_path__ + "media/images/sample/product-1-4ff94a1ca542010e7c214fa009dbe9d5.png";